import api from "./api";

// Envia a adequação final do questionário com JSON e arquivos
// Endpoint: PUT /api/questionarioResposta/enviarAdequacao/{id}
export const enviarAdequacao = async (idQuestionarioResposta, payload) => {
  try {
    const formData = new FormData();

    formData.append("Json", JSON.stringify(payload.Json));
    formData.append(
      "ResponsavelPreenchimento",
      payload.ResponsavelPreenchimento,
    );
    formData.append("CargoResponsavel", payload.CargoResponsavel);
    formData.append("ReceitaOperacional", payload.ReceitaOperacional);
    formData.append("PercentualConclusao", payload.PercentualConclusao);

    formData.append(
      "AdequacaoCamposQuestionarioJson",
      payload.AdequacaoCamposQuestionarioJson,
    );

    (payload.Arquivos || []).forEach((file) => {
      formData.append("Arquivos", file);
    });

    const response = await api.put(
      `/api/questionarioResposta/enviarAdequacao/${idQuestionarioResposta}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error: unknown) {
    const err = error as { response?: { data?: unknown }; message?: string };
    console.error(
      "Erro ao enviar adequação:",
      err?.response?.data || err?.message || error,
    );
    throw error;
  }
};

// Salva a adequação em rascunho do questionário com JSON e arquivos
// Endpoint: PUT /api/questionarioResposta/salvarAdequacao/{id}
export const salvarAdequacao = async (
  idQuestionarioResposta,
  payloadAdequacao,
) => {
  try {
    const formData = new FormData();

    formData.append("Json", payloadAdequacao.Json);
    formData.append(
      "ResponsavelPreenchimento",
      payloadAdequacao.ResponsavelPreenchimento,
    );
    formData.append("CargoResponsavel", payloadAdequacao.CargoResponsavel);
    formData.append("ReceitaOperacional", payloadAdequacao.ReceitaOperacional);
    formData.append(
      "PercentualConclusao",
      payloadAdequacao.PercentualConclusao,
    );

    formData.append(
      "AdequacaoCamposQuestionarioJson",
      payloadAdequacao.AdequacaoCamposQuestionarioJson,
    );

    (payloadAdequacao.Arquivos || []).forEach((file) => {
      formData.append("Arquivos", file);
    });

    const response = await api.put(
      `/api/questionarioResposta/salvarAdequacao/${idQuestionarioResposta}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response.data;
  } catch (e: unknown) {
    const err = e as { response?: { data?: unknown }; message?: string };
    if (err?.response?.data) {
      console.error(
        "❌ Erro Backend:",
        JSON.stringify(err.response.data, null, 2),
      );
    } else {
      console.error("❌ Erro:", err?.message || e);
    }
    throw e;
  }
};
